"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselNavControlsMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _IconButton = require("../../components/IconButton/IconButton.styles");
/** @class PropertyCardPhotoNavigationControlsMixin */
/** @method */
var PhotoCarouselNavControlsMixin = function PhotoCarouselNavControlsMixin(props) {
  return (0, _styledToken.default)({
    iconColor: 'PhotoCarousel.controlIcon.color',
    iconFilterNext: 'PhotoCarousel.controlIcon.next.filter',
    iconFilterPrevious: 'PhotoCarousel.controlIcon.previous.filter'
  }, function (_ref) {
    var iconColor = _ref.iconColor,
      iconFilterNext = _ref.iconFilterNext,
      iconFilterPrevious = _ref.iconFilterPrevious;
    return (0, _styledComponents.css)(["position:static;z-index:1;", "{position:absolute;border-color:transparent;height:100%;&:nth-child(1){left:0;", "{filter:", ";}}&:nth-child(2){right:0;", "{filter:", ";}}&:active,&:hover{background-color:transparent;border-color:transparent;color:", ";}&:focus{box-shadow:none;}&[disabled]{pointer-events:auto;}}"], _IconButton.StyledIconButton, _Icon.StyledIcon, iconFilterPrevious, _Icon.StyledIcon, iconFilterNext, iconColor);
  })(props);
};
exports.PhotoCarouselNavControlsMixin = PhotoCarouselNavControlsMixin;